// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1S57i","footer":"ModalUpdate_footer__390ox"};